import React from 'react';
import ReactHintFactory from 'react-hint';

const ReactHint = ReactHintFactory(React);

export default ReactHint;